import { render, staticRenderFns } from "./MainStepSection.vue?vue&type=template&id=7badd8cd&scoped=true&"
import script from "./MainStepSection.vue?vue&type=script&lang=js&"
export * from "./MainStepSection.vue?vue&type=script&lang=js&"
import style0 from "./MainStepSection.vue?vue&type=style&index=0&id=7badd8cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7badd8cd",
  null
  
)

export default component.exports